import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";

export default function TypeCategorySitePublisher() {
  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-type-category-user-site-publishers-alternative"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نوع دسته سایت های نمایش دهنده جایگزین
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid" id="type-all-campaigns">
                <div className="row">
                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between">
                      <div className="item-name text-center">
                        <b>بنری</b>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center pt-3">
                          <Link
                            className="btn btn-primary"
                            to="/manage/publishers/all-banner-category-site-publisher-alternative"
                          >
                            انتخاب
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between">
                      <div>
                        <div className="item-name text-center">
                          <b>همسان</b>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center pt-3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
